import React from "react";
import axios from "axios";
import { setup as URI_SETUP, host as HOST } from "../../../../../config/api";
import { Steps, Button, Icon, message, Form, Switch, Modal, Table, Input, notification, Select } from 'antd';
import {tblColsNewProduction, monthByNumber} from "../../../../../config/Helpers";

const Step = Steps.Step;
const { TextArea } = Input;
const { Option } = Select;
const ButtonGroup = Button.Group;
const uri_production = URI_SETUP+"production";

const budgetSteps = [{
    title: 'Define',
    content: 'define',
  }, {
    title: 'Fill',
    content: 'fill',
  } /* , {
    title: 'Activate',
    content: 'activate',
  } */];

class ProductionNew extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            current                       : 0,
            production_years              : [],
            production_periods            : [{
                                          key: 'year',
                                          title: 'Year',
                                          table_width: 400
                                            }, {
                                              key: 'month',
                                              title: 'Month',
                                              table_width: 1640
                                            } , {
                                              key: 'day',
                                              title: 'Day',
                                              table_width: 4540
                                            } ], 
            production_depths            : [ /* {
                                              key: 'global',
                                              title: 'Global',
                                            }, */ {
                                              key: 'segment',
                                              title: 'Segment',
                                            }, {
                                              key: 'agency',
                                              title: 'Agency',
                                            }],
            production_bys                : [{
                                              key: 'amount',
                                              title: 'Amount',
                                            }, /* {
                                              key: 'percent',
                                              title: 'Percent',
                                            } */ ],
            input_value_active            : "nights",
            production_matrix_maped       : [],
            sts_production_edit_box       : "arrows-alt",
            is_loading_matrix_table       : true,                 
            active_production             : {
                                            period              : "",
                                            year                : 0,
                                            depth               : "",
                                            expected_growth     : 0,
                                            growth              : 0,
                                            status              : "draft",
                                            short_description   : "",
                                            details             : ""
                                          },
            active_matrix                 : [],
            saved_values                  : [],
            updated_values                : [],
            details                       : "",
            modal_set_live                : false,
            active_month                  : 1
                                          
            }
    }

    componentWillMount(){
        this.getAvailableYears();
        if(this.props.active_production._id!=undefined){
          this.getFullProductionDetails(this.props.active_production._id);
          if(this.state.current<1){
            this.setState({ current : 1 })
          }
          
        }
    } 

    componentDidUpdate(prevProps, prevState) {
      if (prevState.active_production != this.state.active_production) {
        if(this.state.active_matrix!=[]){
          this.mapProductionMatrixRows();
        }   
      }

      if (prevState.input_value_active != this.state.input_value_active) {
        this.mapProductionMatrixRows(this.state.input_value_active);
        this.setState({
          is_loading_matrix_table : false
        });
      }
      
      if (prevState.active_month != this.state.active_month) {
        this.mapProductionMatrixRows(this.state.input_value_active);
        this.setState({
          is_loading_matrix_table : false
        });
      }

      if( prevState.updated_values != this.state.updated_values ){
        if(this.state.updated_values!=undefined){
          var self = this;
          let saved_values = self.state.saved_values;
          let updated_values = self.state.updated_values;
          Object.keys(updated_values).map(function(row, i){
            
            Object.keys(updated_values[row]).map(function(row2, i){ 
              if(saved_values[row]!=undefined){
                saved_values[row][row2] = updated_values[row][row2];
              }else{
                saved_values[row] = updated_values[row];
              }
            });
          });
          this.setState({ saved_values });
          this.mapProductionMatrixRows(this.state.input_value_active);
        }
          
      }
        
    }

    // ----------------------- Handlers -----------------------

    handleMonthChange(active_month) {
      let self = this;
      self.setState({ 
          active_month  
          }) 
    }
    
    handleSetLiveItem(_id) {
      let self = this;
      self.setState({ 
          modal_set_live    : true  
          })  
    }

    handleConfirmSetLive = e => {
      let formData = new FormData();

      notification.open({
        message: 'Notification',
        description: "Now Magnum going to process this data to set it up as a live Production, this process could take several minutes."
      });

      formData.append('api_token',localStorage.getItem("api_token"));
      formData.append('mode',"set_as_visible");
      
      axios.post(uri_production+"/"+this.props.active_production._id, formData)
                  .then(request => { 
                    notification.open({
                      message: request.data.result.type,
                      description: request.data.result.message
                    });
                  })
                  .catch(error => {
                      notification.open({
                          message: 'Unsuccessful',
                          description: "Process Unsuccessful please try again"
                        });
                  });
      this.setState({
          modal_set_live        : false,
      });
      
    };
  
    handleCancelSetLive = e => {
      this.setState({
          modal_set_live        : false,
      });
    };
    
    handleActivateProduction(checked) {
      console.log(`switch to ${checked}`);
    }

    handleProductionInfoInput(e){
        const target = e.target;
        const name = target.name;
        const value = target.value;
        let active_production = this.state.active_production;
        active_production[name] = value;
        this.setState({
            active_production
        });
    }
    
    handleProductionEditBoxStatus(){
      let sts_production_edit_box = this.state.sts_production_edit_box;
      if(sts_production_edit_box=="arrows-alt"){
        sts_production_edit_box="shrink";
      }else{
        sts_production_edit_box="arrows-alt";
      }
      this.setState({ sts_production_edit_box });
    }
    
    handleActiveProduction = (e) => {
        let active_production = Object.assign({}, this.state.active_production);
        active_production[e.target.name] = e.target.value;
        this.setState({  active_production }); 
    }

    handleDetailsInput = (e) => {
      let active_production = Object.assign({}, this.state.active_production);
      active_production[e.target.name] = e.target.value;
      this.setState({  active_production }); 
  }

    

    handleInputMatrixBlur = (e) => {
      let self = this;
      let active_matrix = Object.assign({}, self.state.active_matrix);
      let values = [];
      let row = e.target.getAttribute('data-row');
      let col = e.target.getAttribute('data-col');
      let type = self.state.input_value_active;
      let row_agency=(e.target.getAttribute('data-row-agency')!=undefined)? e.target.getAttribute('data-row-agency') : null ;
      var qs = require("qs");
      
      values['type'] = type;
      values['production_id'] = self.state.active_production._id;
      values['production_status'] = self.state.active_production.status;
      values['col'] = col;
      values['mode'] = "update_input"; 
      values['value'] = Number(e.target.value);
      values["api_token"]=localStorage.getItem("api_token");

      if(row_agency==null){
          values['_id'] = active_matrix[row]._id;
          values['name'] = active_matrix[row].name;
        
      }else{
        values['segment_id'] = active_matrix[row]._id;
        values['segment_name'] = active_matrix[row].name;
        values['_id'] = active_matrix[row].agencies[row_agency]._id;
        values['name'] = active_matrix[row].agencies[row_agency].name;
      }
      const itemToSent = qs.stringify(values);

      axios.post(uri_production+"/"+self.state.active_production._id, itemToSent)
          .then(request => { 
              self.setState({ 
                updated_values         : request.data,
              }); 
          });
    }
    

    handlePercentageGrowth = (value) => {
        let active_production = Object.assign({}, this.state.active_production);
        active_production.expected_growth = Number(value);
        this.setState({  active_production }); 
    }

    handleValueActive (input_value_active) {
      this.setState({ input_value_active, is_loading_matrix_table:true });
    }

    // ----------------------- Functions -----------------------
    
    getFullProductionDetails(id){
        this.setState({ is_loading_matrix_table    : true});
        let self = this;
        axios.get(uri_production+"/"+id, { 
            params: {
                api_token       : localStorage.getItem("api_token")
            }
        }).then(request => { 
            self.setState({ 
                active_production              : request.data.production,
                active_matrix                  : request.data.matrix,
                saved_values                   : request.data.saved_values,
                is_loading_matrix_table        : false
            }) 
        })
    }

    saveProduction(active_production=null){
      let self = this;
      var qs = require("qs");
      
      active_production = (active_production!=null)? active_production : Object.assign({}, this.state.active_production);

      active_production["property_id"] = self.props.hotel_selected;
      active_production["api_token"]=localStorage.getItem("api_token");
      active_production["matrix"]= self.state.active_matrix;
      const itemToSent = qs.stringify(active_production);

      if(active_production._id==undefined){
          axios.post(uri_production, itemToSent)
                  .then(request => { 
                    self.setState({ 
                      active_production   : request.data.production,
                      active_matrix       : request.data.matrix,
                      saved_values        : request.data.saved_values
                    }); 
                  })
      }else{
          axios.post(uri_production+"/"+active_production._id, itemToSent)
          .then(request => { 
            self.setState({ 
              active_production     : request.data.production,
              active_matrix         : request.data.matrix,
              saved_values          : request.data.saved_values
            });
          })

      }
      
    }
    
    mapProductionMatrixRows(input_value_active=null){
      this.setState({ is_loading_matrix_table    : true});
      let maped_rows=[];
      let maped_child_rows=[];
      let maped_child_row={};
      let maped_row={};
      let self=this;
      input_value_active = (input_value_active==null)? self.state.input_value_active : input_value_active;
      let limit = 1;
      switch(self.state.active_production.period){
        case 'month': limit = 12; break;
        case 'day': limit = new Date(self.state.active_production.year, self.state.active_month, 0).getDate(); break;
      }
      
      if(self.state.active_production!=undefined){
        switch(self.state.active_production.depth){
          case "agency":
              self.state.active_matrix.map(function(row, i){
                maped_row={};
                maped_row[self.state.active_production.depth]=row.name;
                maped_row["key"]=self.state.active_production.depth+"row"+i;
                for(let row_cols=1 ; row_cols<= limit; row_cols++){
                  let row_ext=(self.state.active_production.period=='day')?self.state.active_month+"_"+row_cols : row_cols;
                  let show_subtotal = (self.state.saved_values[row._id]==undefined)? false : ((self.state.saved_values[row._id][row_ext]==undefined)? false : ((self.state.saved_values[row._id][row_ext][input_value_active]==undefined)? false : true)); 
                  maped_row[self.state.active_production.depth+row_ext]=
                      <div className="cell-with-input">
                        <div className="cell-subtotal" >{(show_subtotal)? self.state.saved_values[row._id][row_ext][input_value_active].toLocaleString() : 0 }</div>
                      </div>;
                }
                maped_child_rows=[];
                if(row.agencies!=undefined){  
                  row.agencies.map(function(row_agency, k){
                      
                      maped_child_row={};
                      maped_child_row[self.state.active_production.depth]=row_agency.name;
                      maped_child_row["key"]=self.state.active_production.depth+"row_agency"+i+"_"+k;
                      for(let row_agency_cols=1 ; row_agency_cols<= limit; row_agency_cols++){
                        let row_agency_ext=(self.state.active_production.period=='day')?self.state.active_month+"_"+row_agency_cols : row_agency_cols;
                        let show_value = (self.state.saved_values[row_agency._id]==undefined)? false : ((self.state.saved_values[row_agency._id][row_agency_ext]==undefined)? false : ((self.state.saved_values[row_agency._id][row_agency_ext][input_value_active]==undefined)? false : true)); 
                        maped_child_row[self.state.active_production.depth+row_agency_ext]=<div className="cell-with-input">
                              {  (input_value_active=='nights') &&  
                                <input 
                                  defaultValue={(show_value)? self.state.saved_values[row_agency._id][row_agency_ext][input_value_active] : 0 } type="number" 
                                  onBlur={self.handleInputMatrixBlur.bind(self)}
                                  data-col={row_agency_ext} data-row={i} data-row-agency={k}
                                  onFocus={e => e.target.select()} 
                                />
                              }
                              { (input_value_active=='revenue') &&
                                <input 
                                  defaultValue={(show_value)? self.state.saved_values[row_agency._id][row_agency_ext][input_value_active] : 0 } type="number" 
                                  onBlur={self.handleInputMatrixBlur.bind(self)}
                                  data-col={row_agency_ext} data-row={i} data-row-agency={k}
                                  onFocus={e => e.target.select()} 
                                />
                              }   
                              </div>;
                      }
                      maped_child_rows.push(maped_child_row);
                  });
                  maped_row["children"]=maped_child_rows;
                }

                maped_rows.push(maped_row);
                maped_row={};
                

              });
            break;
          default: 
              self.state.active_matrix.map(function(row, i){
                maped_row={};
                maped_row[self.state.active_production.depth]=row.name;
                maped_row["key"]=self.state.active_production.depth+"row"+i;
                for(let row_cols=1 ; row_cols<= limit; row_cols++){
                  let row_ext=(self.state.active_production.period=='day')?self.state.active_month+"_"+row_cols : row_cols;
                  let show_value = (self.state.saved_values[row._id]==undefined)? false : ((self.state.saved_values[row._id][row_ext]==undefined)? false : ((self.state.saved_values[row._id][row_ext][input_value_active]==undefined)? false : true)); 
                  maped_row[self.state.active_production.depth+row_ext]=<div className="cell-with-input">
                            {  (input_value_active=='nights') &&  
                                <input 
                                  defaultValue={(show_value)? self.state.saved_values[row._id][row_ext][input_value_active] : 0 } type="number" 
                                  onBlur={self.handleInputMatrixBlur.bind(self)}
                                  data-col={row_ext} data-row={i}
                                  onFocus={e => e.target.select()} 
                                />
                              }
                              { (input_value_active=='revenue') &&
                                <input 
                                  defaultValue={(show_value)? self.state.saved_values[row._id][row_ext][input_value_active] : 0 } type="number" 
                                  onBlur={self.handleInputMatrixBlur.bind(self)}
                                  data-col={row_ext} data-row={i}
                                  onFocus={e => e.target.select()} 
                                />
                              }  
                        </div>;
                }
                maped_rows.push(maped_row);

              });
            break;
        }

        this.setState({ 
          production_matrix_maped    : maped_rows,
          is_loading_matrix_table    : false
        });

      }
    }

    getAvailableYears(){
        let actual_year = new Date().getFullYear();
        let production_years = [];
        for (let i = (actual_year-1); i < (actual_year+2); i++) {
            production_years.push({
                year            : i,
                status          : ""
            });
        }
        this.setState({ 
            production_years    : production_years
        })        
    }
    
    next() {
      
      let active_production = Object.assign({}, this.state.active_production);
      let current = this.state.current;

      switch(current){
        case 0 : 
          if(active_production.period!='' && active_production.year!=0  && active_production.depth!=''){
            if(active_production._id==undefined){
              
              notification.open({
                message: 'In Progress',
                description: 'MagnumLeap is creating your new Production grid, please wait a moment until it\'s done'
              });

             this.saveProduction(active_production);
            }
            current++;
          } else{
            notification.open({
              message: 'Error',
              description: 'MagnumLeap couldn\'t create de Production grid, please confirm all the obligatory fields are completed'
            });
          }

        break;  
        default:
          current++;

      }

      this.setState({ current });

      }
    
      prev() {
        const current = this.state.current - 1;
        this.setState({ current });
      }

      cancel(){
        this.props.resetActiveProduction();
        this.props.setActiveProductionSection("budget-list");
      }

    // ----------------------- Renders -----------------------
    

    renderSteps(content){
      switch (content){
        case "define":
            return(
              <Form >
                <div className="form-row">
                
                  <div className="col col-md-6">
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="period"
                                onChange={this.handleActiveProduction}
                                value={ this.state.active_production.period }  
                            >
                          <option value="" disabled>Production Period</option>
                          {Object.keys(this.state.production_periods).map(item => <option key={item} value={this.state.production_periods[item].key}>{this.state.production_periods[item].title }</option>)}
                        </select>
                      </div>  
                    </div>
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="year"
                                onChange={this.handleActiveProduction}
                                value={ this.state.active_production.year }  
                            >
                            <option value={0} disabled>Production Year</option>
                            { Object.keys(this.state.production_years).map((key) => {
                                    return( <option key={key} value={this.state.production_years[key].year} >
                                        {this.state.production_years[key].year}
                                    </option>);
                                })
                            }
                        </select> 
                      </div>
                    </div>
                    
                  </div>
                  <div className="col col-md-6">
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="depth"
                                onChange={this.handleActiveProduction}
                                value={ this.state.active_production.depth }  
                            >
                              <option value="" disabled>Production Depth</option>
                              {Object.keys(this.state.production_depths).map(item => <option key={item} value={this.state.production_depths[item].key}>{this.state.production_depths[item].title }</option>)}
                        </select> 
                      </div>
                    </div>
                    

                  </div>
                </div>
              </Form>
            );


          break;
        case "fill":
          return(
            <Form >
              <div className="form-row">

                <div className="col col-md-2">
                  Input Values
                </div>
                <div className="col col-md-4">
                <ButtonGroup>
                  <Button className={(this.state.input_value_active=="nights")?"selected":""} onClick={this.handleValueActive.bind(this,"nights")} >Room Nights</Button>
                  <Button className={(this.state.input_value_active=="revenue" ? "selected" : "") } onClick={this.handleValueActive.bind(this,"revenue")} >Revenue</Button>
                </ButtonGroup>
                </div>
                <div className="col col-md-2 budget-details">
                  <h4>Year</h4> 
                  {this.state.active_production.year}
                </div>
                { this.props.active_production.period=="day" &&
                  <div className="col col-md-2 budget-details">
                    <Select defaultValue={1} onChange={this.handleMonthChange.bind(this)}>
                      <Option value={1}>Jan</Option>
                      <Option value={2}>Feb</Option>
                      <Option value={3}>Mar</Option>
                      <Option value={4}>Apr</Option>
                      <Option value={5}>May</Option>
                      <Option value={6}>Jun</Option>
                      <Option value={7}>Jul</Option>
                      <Option value={8}>Aug</Option>
                      <Option value={9}>Sep</Option>
                      <Option value={10}>Oct</Option>
                      <Option value={11}>Nov</Option>
                      <Option value={12}>Dec</Option>                    
                    </Select>
                  </div>
                }
                
                   
              </div>
              <div className="form-row">
                <div className="col col-md-12">
                  {this.is_loading_matrix_table &&
                    <Icon type="loading" />
                  }
                  { 
                    (this.state.active_production.year!="" && this.state.active_production.production_period!="" && this.state.active_production.production_depth!=""  ) && 
                     <Table 
                        columns={tblColsNewProduction(
                                                  this.state.production_periods.find(period => period.key === this.state.active_production.period), 
                                                  this.state.production_depths.find(depth => depth.key === this.state.active_production.depth), 
                                                  this.state.active_production.year, this.state.active_month)} 
                        scroll={{ x: this.state.production_periods.find(period => period.key === this.state.active_production.period).table_width /*, y : 200 */  }} 
                        dataSource={this.state.production_matrix_maped}
                        pagination={{
                          defaultPageSize : 5
                                  }}
                        loading={this.is_loading_matrix_table}
                        footer={() => <div className={"row"} >
                                        <a target="_blank" href={ HOST + this.state.active_production.csv_file } > <Button icon="import" onClick={() => message.success('Processing complete!')}>Export</Button></a>
                                        <Button icon="export" onClick={() => message.success('Processing complete!')}>Import</Button>
                                      </div> 
                              }
                        />
                  }
                  
                </div>
              </div>
              



            </Form>);         

          break;
        case "activate":
          return(
            <Form >
              <div className="form-row">

                <div className="col col-md-6">
                  <div className="form-row">
                  <div className="col col-md-12">
                      <TextArea 
                        rows={4} placeholder="Production Details" 
                        value={this.state.active_production.details}
                        name="details"
                        onChange={e => this.handleDetailsInput(e)}
                      />
                    </div>
                    <div className="col col-md-10 align-right">
                        Set as active Production
                    </div>
                    <div className="col col-md-2">
                        <Switch onChange={this.handleActivateProduction} />
                    </div>
                  </div>
                </div>
                <div className="col col-md-6">
                </div>

              </div>
            </Form>
          );

          break;
      }
      
    }

    renderConfirmSetLive() {
      return (
          <Modal
            title="Confirm Production Upload"
            visible={this.state.modal_set_live}
            onOk={this.handleConfirmSetLive}
            onCancel={this.handleCancelSetLive}
          >
            <p>Are you sure?. If you confirm, the selected data going to replace the actual one.</p>
          </Modal>
      );
    }

    render() {
        const { current } = this.state;
        
        return (
          <section>
            <div className={"box regular col-md-12 " +  ( this.state.sts_production_edit_box=='shrink'? 'maximized' : '' ) } >
              <h3>
                New Production  
                <Icon className="clickable" type= {this.state.sts_production_edit_box} onClick={this.handleProductionEditBoxStatus.bind(this)} />
              </h3>
              <div className="table-in-box"><br />
                <div className="ant-container budget-steps-box">
                  <Steps current={current}>
                    {budgetSteps.map(item => <Step key={item.title} title={item.title} />)}
                  </Steps>
                  <div className="steps-content steps-budget">
                    <div className="form-in-box">
                      {this.renderSteps(budgetSteps[current].content)}
                    </div>
                  </div>
                  <div className="steps-action">
                    { current > 1 &&  (
                      <div className="col col-md-4">
                        <button onClick={() => this.prev()}>
                          Previous
                        </button>
                      </div>
                    )}
                    { current < budgetSteps.length - 1 && 
                      <div className="col col-md-4">
                        <button className="blue" onClick={() => this.next()}>Next</button>
                      </div>
                    }

                    <div className="col col-md-4">
                      <button className="remove" onClick={() => this.cancel()}>
                        Exit
                      </button>
                    </div>
                    
                    { current === budgetSteps.length - 1 && 
                      <div className="col col-md-4">
                        <button className="blue" onClick={this.handleSetLiveItem.bind(this)}>Set as active Production </button>
                      </div>
                    }
                    
                  </div>
                </div>
              </div>
            </div>
            { this.renderConfirmSetLive() }
          </section>
        );

    }

}

export default ProductionNew


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/production/ProductionEdit.js